module.exports = __webpack_public_path__ + "img/hr-long-handed-inserter-hand-open.bde8273a.png";